import { useParams } from "react-router-dom";
import ExportEntryHeader from "src/components/pages/Exports/ExportEntry/ExportEntryHeader";
import ExportEntrySections from "src/components/pages/Exports/ExportEntry/ExportEntrySections";
import { useGetApi } from "src/hooks";
import { type ISection } from "src/interfaces";
import { PageContainer } from "src/styled";
import { useIsDev } from "src/hooks/useIsDev";
import { useDispatch } from "../../../redux/hooks";
import { setPreferences } from "../../../redux/slices/preferencesSlice";

const mapSections = (data: any) => {
  const sections: ISection[] = data?.data?.lbentry?.sections ?? undefined;
  return {
    sections,
    files: data.data.attachments,
    comments: data.data.comments,
    lbname: data.data.lbname,
    uppercase: data.data.uppercase,
  };
};

const ExportEntry = () => {
  const isDev = useIsDev();
  const { meid } = useParams();
  const dispatch = useDispatch();
  const { data, isLoading } = useGetApi({
    request: "get-review-entry-exports",
    body: { params: { meid } },
    mapper: mapSections,
  });
  if (data?.uppercase) {
    dispatch(setPreferences({ uppercase: data.uppercase }));
  }
  isDev && data && console.log({ data });

  return (
    <PageContainer>
      <ExportEntryHeader
        lbname={data?.lbname}
        comments={data?.comments}
        files={data?.files}
      />
      <ExportEntrySections sections={data?.sections} loading={isLoading} />
    </PageContainer>
  );
};

export default ExportEntry;
